module.exports = __webpack_public_path__ + "static/img/htcx.73391dcc.png";